import { gql } from '@apollo/client';

const AWAITING_UPLOAD_DEVICES_FRAGMENT = gql`
  fragment AwaitingUploadDevicesFragment on Study {
    id
    friendlyId
    deviceType
    deviceId
    device {
      id
      lastSync {
        time
        rssi
        fwVersion
        schema
      }
      additionalStatus
      firstStudyDate
    }
    facility {
      id
      name
      status
    }
  }
`;

export default AWAITING_UPLOAD_DEVICES_FRAGMENT;
